export const UPLOAD_FILE_MAX_SIZE_IN_MB = 20; // MB
export const UPLOAD_FILE_MAX_SIZE_IN_BYTE = UPLOAD_FILE_MAX_SIZE_IN_MB * 1024 * 1024;

export const ACCEPT_FILE_EXTENSIONS = {
  'image/jpg': [],
  'image/jpeg': [],
  'image/png': [],
  'application/pdf': []
};

export const UPLOAD_ERROR_CODES = {
  FILE_TO_LARGE: 'file-too-large',
  FILE_INVALID_TYPE: 'file-invalid-type'
};
